import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, HeaderTemplate, KeyValue, Stepper, TitleHeader } from 'web-library';
import { Theme as AugmentedTheme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';
import { useParams } from 'react-router-dom';
import AccessArrangementRequest from '../../../modules/accessArrangment/components/candidate/AccessArrangementRequest/AccessArrangementRequest';

const useStyles = makeStyles()((theme) =>
({
  stepper: {
    position: 'relative',
    left: '-5%',
    marginTop: theme.spacing(9),
  },
}));

interface AccessArrangementRequestCoordinatorProps {
  routeSteps: { label: string }[];
  amendment?: boolean;
  activeStep: number;
}

const AccessArrangementRequestCoordinator = ({
  routeSteps,
  amendment,
  activeStep,
}: AccessArrangementRequestCoordinatorProps) => {
  const { t } = useTranslation();
  const { classes } = useStyles();
  const { uuid } = useParams<{ uuid: string }>();

  const candidateNameNewApplication =
    localStorage.getItem(`candidateNameNewApplication: ${uuid}`) || '';
  const candidateNameContinueApplication =
    localStorage.getItem(`candidateNameContinueApplication: ${uuid}`) || '';

  const candidateNameAmendmentApplication =
    localStorage.getItem(`candidateNameAmendmentApplication: ${uuid}`) || '';

  return (
    <>
      <TitleHeader
        title={t('accessArrangement->>AccessArrangementRoute.ApplyforAccessArrangements')}
      />
      <HeaderTemplate>
        <KeyValue
          keyText={t('accessArrangement->>CoordinatorSelectCandidate.CandidateName')}
          valueText={
            amendment
              ? candidateNameAmendmentApplication
              : candidateNameNewApplication || candidateNameContinueApplication
          }
        />
        <Box className={classes.stepper}>
          <Stepper activeStep={activeStep} steps={routeSteps} />
        </Box>
      </HeaderTemplate>
      <AccessArrangementRequest amendment={amendment} />
    </>
  );
};

export default AccessArrangementRequestCoordinator;
